import { z } from 'zod';
import { ERROR_CODES } from '../constants/index.js';
export const idSchema = z.coerce.number().int().positive();
export const isoDateTimeSchema = z
    .string()
    .datetime({ offset: true })
    .or(z.string().datetime())
    .describe('ISO-8601 date-time in UTC');
export const hhmmSchema = z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Formato esperado HH:mm');
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
    sortBy: z.string().max(60).optional(),
    sortDir: z.enum(['asc', 'desc']).default('asc'),
    search: z.string().trim().max(120).optional(),
});
export const paginationMetaSchema = z.object({
    page: z.number().int(),
    pageSize: z.number().int(),
    total: z.number().int(),
    totalPages: z.number().int(),
});
export const errorCodeSchema = z.enum(Object.values(ERROR_CODES));
export const apiErrorSchema = z.object({
    code: errorCodeSchema,
    message: z.string(),
    details: z.unknown().optional(),
    correlationId: z.string().optional(),
});
export const workingHoursSchema = z.object({
    /** 0 = Sunday … 6 = Saturday */
    weekday: z.number().int().min(0).max(6),
    enabled: z.boolean().default(true),
    start: hhmmSchema,
    end: hhmmSchema,
});
export const workingHoursListSchema = z.array(workingHoursSchema).max(7);
//# sourceMappingURL=common.js.map